"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modules = void 0;
var _modules = _interopRequireWildcard(require("./loaders"));
var _MapSourceModule2 = _interopRequireDefault(require("./MapSourceModule"));
var _ModuleGroup2 = _interopRequireDefault(require("./ModuleGroup"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
var Modules;
(function (Modules) {
  Modules.MapSourceModule = _MapSourceModule2.default;
  Modules.ModuleGroup = _ModuleGroup2.default;
  // modules
  Modules.aviation = {
    FlightRules: _modules.FlightRules,
    Sigmets: _modules.Sigmets,
    StationPlots: _modules.StationPlots
  };
  Modules.tropical = {
    Systems: _modules.Systems,
    Invests: _modules.Invests,
    Windfields: _modules.Windfields,
    Breakpoints: _modules.Breakpoints,
    utils: _modules.TropicalUtils
  };
  Modules.Routing = _modules.Routing;
  // groups
  Modules.groups = {
    Aviation: _modules.Aviation,
    Tropical: _modules.Tropical
  };
})(Modules || (exports.Modules = Modules = {}));